
import {getCreditLive} from '../api/getCreditLive';
import {setGetCreditLiveAction} from '../action';

const setGetCreditLive = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCreditLive(params);

            if (data.status === 'success') {
                dispatch(setGetCreditLiveAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetCreditLive
}